import { render, staticRenderFns } from "./clearAttention.vue?vue&type=template&id=0f303707&scoped=true&"
import script from "./clearAttention.vue?vue&type=script&lang=js&"
export * from "./clearAttention.vue?vue&type=script&lang=js&"
import style0 from "./clearAttention.vue?vue&type=style&index=0&id=0f303707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f303707",
  null
  
)

export default component.exports